// extracted by mini-css-extract-plugin
export default {"wrapper":"Fieldset_wrapper__DocEv","title":"Fieldset_title__W5HdL"};